<template>
  <q-dialog ref="dialogRef" persistent @hide="onDialogHide">
    <q-card style="width: 600px" class="relative-position elevation-1">
      <q-card-section
        class="flex justify-between items-center q-px-2x-md q-py-xl"
      >
        <span class="text-lg text-neutral text-weight-medium">Add Contact</span>
        <PBtn flat round size="sm" @click="onDialogCancel">
          <CloseIcon class="icon" />
        </PBtn>
      </q-card-section>

      <q-separator />

      <q-card-section
        class="rounded-borders text-neutral-90 text-center q-px-2x-md q-py-xl"
      >
        <AddContactForm
          :contact-number="contactNumber"
          :first-name="firstName"
          :last-name="lastName"
          @contact-created="onContactCreated"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { useDialogPluginComponent } from "quasar";
import CloseIcon from "assets/icons/close.svg";

defineEmits([...useDialogPluginComponent.emits]);

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } =
  useDialogPluginComponent();

const props = defineProps({
  contactNumber: {
    type: String,
    default: "",
  },
  firstName: {
    type: String,
    default: "",
  },
  lastName: {
    type: String,
    default: "",
  },
  updateContactExists: {
    type: Function,
    default: () => {},
  },
});

const onContactCreated = (contact) => {
  props.updateContactExists(true);

  onDialogOK(contact);
};
</script>
